/**
 * constants.js
 *
 * Shared constants used across the teleprompter.
 * Note:
 *   - Auth/payment constants live in accessControl.js
 *   - ICE/WebRTC constants live in iceConfig.js
 *   - Stripe links live in accessControl.js
 */

// ── Script ───────────────────────────────────────────────────
export const DEFAULT_SCRIPT = `Ladies and gentlemen, welcome. Today we gather not simply to mark an occasion, but to reflect on something far more enduring — the power of words. Every speech, every story, every declaration that has ever moved a crowd or changed a mind began as a thought. A quiet, unspoken idea that dared to reach for language. Words are not merely tools. They are bridges. Between what we feel and what others can understand. Between who we are and who we wish to become. Use them with care. Use them with courage. And above all — use them with honesty. Thank you.`;

export const LS_KEY         = "tp-prefs-v1";
export const LS_SCRIPTS_KEY = "tp-scripts-v1";
export const MAX_SLOTS      = 6;

// ── Fonts ────────────────────────────────────────────────────
export const FONTS       = ["serif", "mono", "sans"];
export const FONT_LABELS = { serif: "Aa", mono: "><", sans: "Ab" };

// ── Speed presets ─────────────────────────────────────────────
export const SPEED_PRESETS = [
  { label: "Slow", value: 2 },
  { label: "Med",  value: 4 },
  { label: "Fast", value: 7 },
  { label: "Live", value: 10 },
];

// ── Live cue presets ──────────────────────────────────────────
// `icon` is a key resolved to an SVG in CueLabelIcon (Overlays.jsx)
export const QUICK_CUES = [
  { icon: "standby",  label: "Stand by",     bg: "#1a1a2e", accent: "#d4af37" },
  { icon: "onair",    label: "On Air",        bg: "#2a0a0a", accent: "#ff4444" },
  { icon: "timer",    label: "60 seconds",    bg: "#0a1a2a", accent: "#4fc3f7" },
  { icon: "timer",    label: "30 seconds",    bg: "#0a1a2a", accent: "#ffb74d" },
  { icon: "timer",    label: "10 seconds",    bg: "#2a1000", accent: "#ff7043" },
  { icon: "mic",      label: "Mic check",     bg: "#0a1a0a", accent: "#81c784" },
  { icon: "cut",      label: "Cut",           bg: "#2a0a0a", accent: "#ef5350" },
  { icon: "hold",     label: "Hold",          bg: "#1a1500", accent: "#ffd54f" },
  { icon: "clear",    label: "Clear",         bg: "#0a1a0a", accent: "#66bb6a" },
  { icon: "quiet",    label: "Quiet please",  bg: "#100a1a", accent: "#ce93d8" },
  { icon: "thumbsup", label: "Great take",    bg: "#0a1a0a", accent: "#a5d6a7" },
  { icon: "again",    label: "Again please",  bg: "#1a1000", accent: "#d4af37" },
];

// ── Pro feature list (shown in LoginPage upgrade view) ────────
// `icon` is a key resolved to an SVG in ProFeatureIcon (Overlays.jsx)
export const PRO_FEATURES = [
  { icon: "mic",    label: "Voice-activated scroll" },
  { icon: "camera", label: "Camera recording" },
  { icon: "screen", label: "Screen background overlay" },
  { icon: "qr",     label: "QR remote control" },
  { icon: "cue",    label: "Live cue messages" },
  { icon: "doc",    label: "Unlimited script length" },
];


export const IS_PRO = true; // ← change this to toggle everything